import { Injectable } from '@angular/core';
import { AuthService } from '@app-core/services/auth/auth.service';
import { ProfileService } from '@app-services/profile/profile.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, EMPTY } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as actions from '../../actions/index';

@Injectable()
export class PorfileEffect {
  constructor(
    private actions$: Actions,
    private profileService: ProfileService,
    private authService: AuthService
  ) {}

  loadPofileUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadProfile),
      mergeMap((action) =>
        this.profileService.getUserInformation(action.userId).pipe(
          map((user) => {
            const dataSession = this.authService.getTokenCokie();
            return actions.setProfile({
              user: { ...user, id: dataSession?.user?.profile },
            });
          }),
          catchError(() => EMPTY)
        )
      )
    )
  );

  loadProfileOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.loadProfileOptions),
      mergeMap(() =>
        combineLatest([this.profileService.getMaritalStatuses()]).pipe(
          map(([maritalStatuses]) => {
            return actions.setOptionsProfile({
              maritalStatuses: maritalStatuses?.marital_statuss,
            });
          }),
          catchError(() => EMPTY)
        )
      )
    )
  );
}
